import axios from 'axios';

export function logoutUser() {
  return axios.post('/logout', { data: {} });
}
